import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

class ErrorBoundary extends React.Component {
  state = { error: false };
  static getDerivedStateFromError() { return { error: true }; }
  render() {
    if (this.state.error) return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#F2F6F7', fontFamily: 'Inter, sans-serif', padding: 24, textAlign: 'center' }}>
        <svg viewBox="0 0 44 44" width="44" height="44" fill="none" style={{ marginBottom: 16 }}>
          <circle cx="22" cy="22" r="20" stroke="#9FCAD2" strokeWidth="1.5"/>
          <circle cx="22" cy="11.5" r="2.5" fill="#9FCAD2"/>
          <path d="M19.5 16L12 9" stroke="#9FCAD2" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M24.5 16L32 9" stroke="#9FCAD2" strokeWidth="1.5" strokeLinecap="round"/>
          <line x1="22" y1="14" x2="22" y2="27" stroke="#9FCAD2" strokeWidth="1.5" strokeLinecap="round"/>
          <line x1="22" y1="27" x2="15" y2="35" stroke="#9FCAD2" strokeWidth="1.5" strokeLinecap="round"/>
          <line x1="22" y1="27" x2="29" y2="35" stroke="#9FCAD2" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <p style={{ color: '#1F4E5A', fontSize: 16, marginBottom: 20 }}>Something went wrong. Please refresh the page.</p>
        <button onClick={() => window.location.reload()}
          style={{ background: '#1F4E5A', color: '#F2F6F7', border: 'none', borderRadius: 8, padding: '11px 28px', fontSize: 15, cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
          Refresh
        </button>
      </div>
    );
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register the minimal service worker so Chrome treats the app as installable and
// fires the native install prompt. Production only — a SW on the dev server causes
// confusing caching during development.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
